// Tabs — underline tab strip: icon + label + optional count badge per tab,
// brand underline/text on the active one. Purely controlled.

import Icon from './Icon';

export interface TabItem {
  value: string;
  label: string;
  /** Kebab-case Icon name shown before the label. */
  icon?: string;
  /** Small count badge after the label. */
  count?: number;
}

export interface TabsProps {
  value: string;
  onChange: (value: string) => void;
  items: TabItem[];
  'aria-label'?: string;
}

const Tabs = ({ value, onChange, items, 'aria-label': ariaLabel }: TabsProps) => (
  <div className='app-tabs' role='tablist' aria-label={ariaLabel}>
    {items.map((item) => {
      const active = item.value === value;
      return (
        <button
          key={item.value}
          type='button'
          role='tab'
          aria-selected={active}
          className={`app-tabs__tab${active ? ' is-active' : ''}`}
          onClick={() => onChange(item.value)}
        >
          {item.icon && <Icon name={item.icon} size={16} />}
          {item.label}
          {item.count !== undefined && <span className='app-tabs__count'>{item.count}</span>}
        </button>
      );
    })}
  </div>
);

export default Tabs;
